import { Cell, flexRender } from '@tanstack/react-table';
import styled from 'styled-components';
import Checkbox from '#/components/Checkbox';

type ExpandableCellProps<T> = {
  cell: Cell<T, unknown>;
};

const ExpandableCell = <T,>({ cell }: ExpandableCellProps<T>) => {
  const { depth, getIsExpanded, toggleExpanded } = cell.row;
  const context = cell.getContext();
  return (
    <CellLeftPadding depth={depth}>
      <Content>
        <Checkbox
          onCheck={() => {
            toggleExpanded();
          }}
          indeterminate
          isChecked
          variant="filled"
          state={getIsExpanded() ? 'LINE' : 'ARROW'}
        />

        {flexRender(cell.column.columnDef.cell, context)}
      </Content>
    </CellLeftPadding>
  );
};

export default ExpandableCell;

const CellLeftPadding = styled.div<{ depth: number }>`
  padding-left: ${({ depth }) => (depth > 0 ? 16 * depth : 0)}px;
  display: flex;
`;
const Content = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: auto auto;
`;
